module.exports = __webpack_public_path__ + "img/continue-button.4a2c0b91.png";